@if (showUI()) {
    <div class="flex flex-col min-h-screen">
        <app-header />

        <div class="px-2">
            <aside
                class="md:visible top-0 md:top-[69px] left-0 md:left-0 z-100 fixed bg-white md:bg-transparent dark:bg-none pb-16 border-r border-r-gray-200 dark:border-r-gray-700 w-[200px] w-[200px] md:w-[200px] h-full overflow-y-auto"
                [ngClass]="{ 'visible left-0': isMobileMenuOpen(), 'left-[-200px]': !isMobileMenuOpen() }"
            >
                <app-side-menu />
            </aside>
            <div
                class="top-0 left-0 z-20 fixed bg-gray-800 dark:bg-white opacity-50 w-full h-screen"
                [ngClass]="{ hidden: !isMobileMenuOpen() }"
            ></div>

            <app-main [bgColor]="bgColor" [hasBorder]="false">
                <router-outlet class="hidden"></router-outlet>
            </app-main>
        </div>
    </div>
    <p-toast position="bottom-center" />
}

@if (showTenantError()) {
    <app-error-full-page
        title="Tenant Doesn't Exist"
        message="The tenant you are trying to access does not exist, please contact support."
    />
    <p-toast position="bottom-center" />
}
